"use strict";

exports.__esModule = true;
exports.PLUGIN_PRIORITY = exports.PLUGIN_KEY = exports.Filters = void 0;
var _filters = require("./filters");
exports.PLUGIN_KEY = _filters.PLUGIN_KEY;
exports.PLUGIN_PRIORITY = _filters.PLUGIN_PRIORITY;
exports.Filters = _filters.Filters;


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/filters/index.js
// module id = 1409
// module chunks = 0